// Constants
import { PremiumPlanLicenseLevel } from "./configuration/premiumPlanSettings/FeatureEntitlements";
/**
 * Ordered numeric tiers for user licenses.
 * Higher values indicate higher license tiers, enabling direct comparison with >=, >, etc.
 */ export var LicenseTier = /*#__PURE__*/ function(LicenseTier) {
    /** No license */ LicenseTier[LicenseTier["None"] = 0] = "None";
    /** Read-only access to legacy premium plans */ LicenseTier[LicenseTier["ReadOnlyPremium"] = 1] = "ReadOnlyPremium";
    /** Premium P1 */ LicenseTier[LicenseTier["P1"] = 2] = "P1";
    /** Premium P3 */ LicenseTier[LicenseTier["P3"] = 3] = "P3";
    /** Premium P5 */ LicenseTier[LicenseTier["P5"] = 4] = "P5";
    return LicenseTier;
}({});
/**
 * Maps premium plan license levels to their corresponding license tiers.
 */ export const PremiumLicenseLevelToTierMapping = {
    [PremiumPlanLicenseLevel.basic]: 1,
    [PremiumPlanLicenseLevel.basicPlus]: 1,
    [PremiumPlanLicenseLevel.standard]: 2,
    [PremiumPlanLicenseLevel.professional]: 3,
    [PremiumPlanLicenseLevel.premium]: 4
};
